import AwardEntry from './AwardEntry';
import Work from './Work';

class AwardEntryWithWorks {
  awardEntry = null;
  
  works = [];

  constructor(data) {
    this.awardEntry = AwardEntry.fromObject(data.awardEntry);
    this.works = Work.fromObjectList(data.works);
  }

  get workCount() {
    return this.works?.length ?? 0;
  }

  get displayTextWithCount() {
    return `${this.awardEntry.displayText} (No.of Works: ${this.workCount})`;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new AwardEntryWithWorks(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => AwardEntryWithWorks.fromObject(data));
  }
}

export default AwardEntryWithWorks;
